import {
  create_request_order,
  update_request_order,
  delete_request_order,
  recover_request_order,
  query_request_order_list,
} from '@/api/jms-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/jms/jms-requestorder-config';

import { reactive } from 'vue';
import { get_is_active, getDate, getDateTime, toFixed0 } from '@/utils/function';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '报单单号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写报单单号',
    },
    {
      type: 'remotemodal',
      name: 'franchisee_id',
      label: '加盟商',
      disabled: false,
      placeholder: '请选择加盟商',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-franchisee',
    },
    {
      type: 'remotemodal',
      name: 'product_id',
      label: '产品',
      disabled: false,
      placeholder: '请选择产品',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-product',
    },
    {
      type: 'rangepicker',
      name: 'date',
      label: '报单时间',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      placeholder: '请填写报单时间',
    },
    {
      type: 'rangepicker',
      name: 'do_time',
      label: '审批时间',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      placeholder: '请填写审批时间',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    code: null,
    franchisee_id: null,
    product_id: null,
    date: null,
    status: null,
    do_time: null,
  }),
};
const search_options = {
  status: [
    { value: None, name: '全部' },
    { value: 0, name: '已提交' },
    { value: 1, name: '已通过' },
    { value: 2, name: '已拒绝' },
    { value: 3, name: '已取消' },
    { value: 4, name: '已撤单' },
  ],
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    // {
    //   type: 'remotemodal',
    //   name: 'franchisee_id',
    //   label: '加盟商',
    //   disabled: false,
    //   placeholder: '请选择加盟商',
    //   datasourceType: 'remote',
    //   mode: 'default',
    //   allowClear: true,
    //   modalType: 'jms-franchisee',
    // },
    {
      type: 'remotemodal',
      name: 'product_id',
      label: '产品',
      disabled: false,
      placeholder: '请选择产品',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-product',
    },
    {
      type: 'input',
      name: 'num',
      label: '产品数量',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写产品数量',
    },
    {
      type: 'datepicker',
      name: 'date',
      label: '报单时间',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      format: 'YYYY-MM-DD',
      valueFormat: 'YYYY-MM-DD',
      placeholder: '请填写报单时间',
    },
  ],
  rules: {
    product_id: [{ required: true, message: '请填输入产品' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    franchisee_id: null,
    product_id: null,
    num: null,
    date: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'remotemodal',
      name: 'franchisee_id',
      label: '加盟商',
      disabled: false,
      placeholder: '请选择加盟商',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-franchisee',
    },
    {
      type: 'remotemodal',
      name: 'product_id',
      label: '产品',
      disabled: false,
      placeholder: '请选择产品',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-product',
    },
    {
      type: 'input',
      name: 'num',
      label: '产品数量',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写产品数量',
    },
    {
      type: 'datepicker',
      name: 'date',
      label: '报单时间',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: true,
      placeholder: '请填写报单时间',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    franchisee_id: null,
    product_id: null,
    num: null,
    date: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '报单管理',
  addModalTitle: '新建报单',
  updateTitle: '修改报单',
  is_create: true, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    requestorder_id: 'id',
  },
  delete: {
    requestorder_id: 'id',
  },
  recover: {
    requestorder_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    requestorder_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
  },
  {
    title: '加盟商ID',
    width: 150,
    dataIndex: 'franchisee_id',
    checked: false,
  },
  {
    title: '加盟商',
    width: 150,
    dataIndex: 'franchisee__name',
    checked: false,
  },
  {
    title: '产品名称',
    width: 100,
    dataIndex: 'product__name',
    checked: true,
  },
  {
    title: '产品编号',
    width: 100,
    dataIndex: 'product__code',
    checked: true,
  },
  {
    title: '产品数量',
    width: 100,
    dataIndex: 'num',
    checked: true,
  },
  {
    title: '产品单价',
    width: 100,
    dataIndex: 'price',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '产品金额',
    width: 100,
    dataIndex: 'total_price',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '报单时间',
    width: 100,
    dataIndex: 'date',
    checked: true,

    content: (record: any, text: any) => {
      return getDate(text);
    },
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    checked: true,
    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '状态',
    width: 100,
    dataIndex: 'status',
    checked: true,
    content: (record: any, text: any) => {
      let content = '';
      switch (text) {
        case 0:
          content = '已提交';
          break;
        case 1:
          content = '已通过';
          break;
        case 2:
          content = '已拒绝';
          break;
        case 3:
          content = '已取消';
          break;
        case 4:
          content = '已撤单';
          break;
        default:
          content = '';
          break;
      }
      return content;
    },
    filterMultiple: true,
    filters: [
      { text: '全部', value: '' },
      { text: '已提交', value: '0' },
      { text: '已通过', value: '1' },
      { text: '已拒绝', value: '2' },
      { text: '已取消', value: '3' },
      { text: '已撤单', value: '4' },
    ],
  },
  {
    title: '备注',
    width: 150,
    dataIndex: 'mark',
    checked: true,
  },
  // 不显示字段
  {
    title: '报单单号',
    width: 150,
    dataIndex: 'code',
    checked: false,
  },
  {
    title: 'ID',
    width: 150,
    dataIndex: 'id',
    checked: false,
  },
  {
    title: '产品ID',
    width: 150,
    dataIndex: 'product_id',
    checked: false,
  },
  {
    title: '审批时间',
    width: 150,
    dataIndex: 'do_time',
    checked: false,

    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '更新时间',
    width: 150,
    dataIndex: 'update_time',
    checked: false,

    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '是否可用',
    width: 150,
    dataIndex: 'is_active',
    checked: false,
    cellComponent: 'boolean',
    name1: '可用',
    name2: '禁用',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active(text);
    },
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'action',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push(
  {
    type: 'custom',
    slotName: 'status',
    field_0: '已提交',
    field_1: '已通过',
    field_2: '已拒绝',
    field_3: '已取消',
  },
  { type: 'custom', field_true: '可用', field_false: '作废' },
);

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_request_order_list,
    addData: create_request_order,
    updateData: update_request_order,
    removeData: delete_request_order,
    recoverData: recover_request_order,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
